<div
  #container
  [ngClass]="{
    'roll-toast roll-widget': true,
    'roll-toast-top-right': position === 'top-right',
    'roll-toast-top-left': position === 'top-left',
    'roll-toast-bottom-right': position === 'bottom-right',
    'roll-toast-bottom-left': position === 'bottom-left',
    'roll-toast-top-center': position === 'top-center',
    'roll-toast-bottom-center': position === 'bottom-center',
    'roll-toast-center': position === 'center'
  }"
  [class]="styleClass">
  <app-toast-item
    *ngFor="let msg of messages; let i = index"
    [message]="msg"
    [index]="i"
    (closeToast)="onMessageClose($event)"
    @toastAnimation
    (@toastAnimation.start)="onAnimationStart($event)"
    [showTransitionOptions]="showTransitionOptions"
    [hideTransitionOptions]="hideTransitionOptions">
  </app-toast-item>
</div>
